import React, { useState, useEffect, useRef } from "react";
import { formatMoneda, formatoMonto, validaMonto } from "../../util/varios";
import { Mensaje } from "../mensajes";
import { Dimmer } from "../spinner";

import axios from "axios";
import useTable from "../useTable";
import { AgregarSolicitud } from "./modalAgregarSolicitudes";
import { fontSize, margin, maxHeight, padding, textTransform } from "@mui/system";
/* import { AgregarCuentas } from './modalAgregarCuentas'; */

function TablaSolicitudesComprasAprobar(props) {
  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");

  const headCells = [
    {
      id: "1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "N° Documento",
      textAlign: "center",
      fontSize: "12px",
      textTransform: 'uppercase'
    },
    {
      id: "11",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "Concepto",
      textAlign: "left",
      fontSize: "12px",
      textTransform: 'uppercase'
    },
    {
      id: "14",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "Opciones",
      textAlign: "center",
      fontSize: "12px",
      textTransform: 'uppercase'
    },
  ];

  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [mostrar, setMostrar] = useState(false);
  const [mostrar5, setMostrar5] = useState(false);
  const [activate, setActivate] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const txtMonto = useRef([]);
  const txtMontoTotal = useRef();

  const blanquearCampos = () => {
    setMostrar(false);
    setTitulo("");
    setMsg("");
  };

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
  useTable(records, headCells, filterFn, 220);

  const handleCloseMensa = () => {
    setMostrar(false);
    blanquearCampos();
  };

  const cerrarModalActualizar = () => {
    setMostrar5(false);
  };

  const opciones = (ope, index) => (event) => {
    event.preventDefault();
    blanquearCampos();

    if (ope === 1) {
      setMostrar5(true);
      setOperacion(1);
      blanquearCampos();
    }
    if (ope === 3) {
    }
  };

  const handleAceptarDatos = (datos) => {
    setMostrar5(false);

    console.log(datos);

    let data = [...records];

    for (let i = 0; i < datos.length; i++) {
      data.push({
        idordenpago: datos[i].idordencompra,
        concepto: datos[i].concepto,
        idaprobacionesdetalle: 0,
        tipo: datos[i].tipo,
        val: datos[i].val,
      });
    }

    setRecords(data);
    props.data(data);
  };

  useEffect(() => {
    if (props.datarecords.length > 0) {
      var data = [...props.datarecords];
      var datos = [];

      for (let i = 0; i < data.length; i++) {
        datos.push({
          idordenpago: data[i].idordenpago,
          concepto: data[i].concepto,
          idaprobacionesdetalle: data[i].idaprobacionesdetalle,
          tipo: data[i].tipo,
        });
      }

      console.log(datos);
      setRecords(datos);
    }
  }, [props.datarecords]);

  const eliminarSolicitud = (item) => (e) => {
    e.preventDefault();

    var datos = [...records];
    var elementos = [];

    for (let i = 0; i < datos.length; i++) {
      if (item.idordenpago !== datos[i].idordenpago) {
        elementos.push(datos[i]);
      }
    }

    setRecords(elementos);
    props.data(elementos);
  };

  return (
    <div>
      <AgregarSolicitud
        show={mostrar5}
        operacion={operacion}
        onDatos={handleAceptarDatos}
        onHideCancela={cerrarModalActualizar}
        esaumento={props.camptab === "Aumento" ? true : false}
      />
      <Mensaje
        titulo={titulo}
        mensaje={msg}
        show={mostrar}
        onHide={handleCloseMensa}
      />

      <Dimmer active={activate} inverted></Dimmer>
      <div className="col-md-12 mb-1 text-end">
        <button
          onClick={opciones(1, "")}
          disabled={
            props.operacion === 4 || props.operacion === 2 ? true : false
          }
          className="btn btn-primary btn-sm rounded-pill"
        >
          <i className="fas fa-plus" />
        </button>
      </div>
      <div className="row col-md-12 mx-auto m-0">
        <div className="col-md-12 m-0 px-0 mb-1">
          <TblContainer>
            <TblHead />

            <tbody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr
                    key={item + item.idcuenta}
                    className="table-bordered"
                    style={{ padding: "0" }}
                  >
                    <td
                      style={{
                        fontSize: "14px",
                        textAlign: "center",
                        width: "100px",
                        
                      }}
                    >
                      {item.idordenpago}
                    </td>
                    <td
                      style={{
                        fontSize: "14px",
                        textAlign: "left",
                        width: "auto",
                      }}
                    >
                      {item.concepto}
                    </td>
                    <td
                      ssName="align-baseline"
                      style={{
                        fontSize: "14px",
                        textAlign: "center",
                        width: "60px",
                      }}
                    >
                      <button
                        onClick={eliminarSolicitud(item)}
                        disabled={
                          props.operacion === 4 || props.operacion === 2
                            ? true
                            : false
                        }
                        className="btn btn-danger btn-sm rounded-circle"
                      >
                        <i className="fa fa-trash-alt"></i>
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          {/* <TblPagination /> */}
        </div>
      </div>
    </div>
  );
}

export default TablaSolicitudesComprasAprobar;
